export const translations = {
    BUTTON_PROCEED: 'newUserRequirements-proceed',
    BUTTON_LOGIN: 'newUserRequirements-buttonLogin',
};
